import React from 'react';
import { get, find, isEmpty } from 'lodash';

// local dependencies
import { setPatientNotes as SetPatientNotesView } from 'ui/views/widgets/setPatientNotes';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS, SIZES } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import { SetPatientNotesService } from 'services/setPatientNotes';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { SetPatientNotes } from 'ui/containers/SetPatientNotes';
 *
 * // render
 * <SetPatientNotes propName='propValue'/>
 */
export class SetPatientNotes extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = this.composeStateFromProps();

        this._bind();
        this.setPatientNotesService = new SetPatientNotesService();
    }

    _bind() {
        log.debug( 'SetPatientNotes._bind()' );

        this.onFormSubmit = this.onFormSubmit.bind( this );
        this.composeStateFromProps = this.composeStateFromProps.bind( this );
        this.handleFormChangeCallback = this.handleFormChangeCallback.bind( this );
        this.updateNotesView = this.updateNotesView.bind( this );
    }

    composeStateFromProps() {
        log.debug( 'SetPatientNotes.composeStateFromProps()' );

        return {
            options: get( this.props, 'options', {} ),
            fields: this.props.fields,
            values: this.props.values,
            isAdd: false
        };
    }

    handleFormChangeCallback( /* { values, field } */ ) {
        log.debug( 'SetPatientNotes.handleFormChangeCallback()' );

        /*-------------------*/

        /*-------------------*/
    }

    /**
     * action executed when MSR clicks on the submit button
     */
    async onFormSubmit( formData ) {
        log.debug( 'SetPatientNotes.onFormSubmit()' );

        const successAction = find( this.props.actions, { name: 'submit' } );

        // cancel ongoing request
        this.setPatientNotesService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        const { status } = await this.setPatientNotesService.submitFormData( {
            url: successAction.url,
            data: {
                context: this.props.context,
                data: formData
            }
        } );

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            this.fetchPatientNotesData();
        } else {
            
            // hide page preloader
            pageLevelPreloader.hide();

            errorOverlay.open();
        }
    }

    async fetchPatientNotesData() {
        log.debug( 'SetPatientNotes.fetchPatientNotesData()' );

        // cancel ongoing request
        this.setPatientNotesService.cancel();

        // get status and service data
        const { status, data } = await this.setPatientNotesService.setPatientNotesData( {
            url: this.props.url,
            data: {
                context: this.props.context
            }
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            
            this.setState( { values: data.values, isAdd: false } );

        } else {

            if( ! isEmpty( get( data, 'description' ) ) ) {
                errorOverlay.open( { message: data.description, size: SIZES.SMALL, } );
            } else {
                errorOverlay.open();
            }
        }
    }

    /**
     * action executed when the popover view is changed
     */
    updateNotesView( value ) {
        log.debug( 'SetPatientNotes.updateNotesView()' );
        
        this.setState( { isAdd: value } );

    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <SetPatientNotesView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.onFormSubmit }
                onChangeCallBack={ this.handleFormChangeCallback }
                setAdd={ this.updateNotesView }
            />
        );
    }
}

// set display name
SetPatientNotes.displayName = 'SetPatientNotes';

// set default props
SetPatientNotes.defaultProps = {};

// prop types
SetPatientNotes.propTypes = {};
